export default __webpack_public_path__ + "static/media/psl_logo.a0e974b5.png";